export function usePopup(map) {
  function centerPopup(markerLocation, popup, {
    height,
    offset
  } = {}) {
    if (!map) return;
    const px = map.project(markerLocation);
    px.x -= offset?.x || 0;
    px.y -= (height || popup.getElement().clientHeight) / 2 + (offset?.y || 0) / 2;
    map.stop();
    map.panTo(map.unproject(px), {
      animate: true
    });
  }
  return {
    centerPopup
  };
}